import { Component, OnInit, OnDestroy } from '@angular/core';
import { PlantService } from 'src/app/services/plant.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ExcelDataProvider } from 'src/app/_Core/_Providers/excel.provider';
// import { AppStateProvider } from 'src/app/_Core/_Providers/app-state.provider';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Observable, Observer } from "rxjs";
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-bulk-upload',
  templateUrl: './bulk-upload.component.html',
  styleUrls: ['./bulk-upload.component.scss']
})
export class BulkUploadComponent implements OnInit, OnDestroy {
  formData: FormData;
  uploadFile: any;
  fileName: any;
  success: boolean;
  templateUrl: any;
  base64Image: any;
  baseUrl;

  constructor(
    private router: Router,
    private plantService: PlantService,
    private excelProvider: ExcelDataProvider,
    private activatedRoute: ActivatedRoute,
    // private appStateSrv: AppStateProvider
    private appStateSrv: AppStateProvider,
    private sideNavService: SidenavService,
  ) { }

  ngOnInit(): void {
    let parkId = localStorage.getItem("parkId") ?? 1;
    this.baseUrl = `${environment.apiBaseUrl}api/BlobStorage/DownloadTemplateFile?fileName=Vegetation_bulk_upload.xlsx`;
    this.activatedRoute.queryParams.subscribe((res) => {
      this.success = res?.sucess ? res?.sucess : false;
    });
    // this.downloadFile()
  }
  ngOnDestroy() {
    localStorage.removeItem('expandNavLand');

    // this.subscriptions.unsubscribe();
  }

  handleFileSelect(evt) {
    var files = evt.target.files;
    var xl2json = new this.excelProvider.ExcelToJSON();
    xl2json
      .parseExcel(files[0])
      .then((data) => {
        // this.prepareTableData(JSON.parse(data));
        this.plantService.setExcelData(data);
        this.router.navigate(['/bulk-upload-preview/']);
      })
      .catch((err) => {
        console.log('Failed to read excel ', err);
      });
  }

  getBase64ImageFromURL(url: string) {
    return Observable?.create((observer: Observer<string>) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = "Anonymous";
      img.src = url;
      if (!img.complete) {
        img.onload = () => {
          observer.next(this.getBase64Image(img));
          observer.complete();
        };
        img.onerror = err => {
          observer.error(err);
        };
      } else {
        observer.next(this.getBase64Image(img));
        observer.complete();
      }
    });
  }

  getBase64Image(img: HTMLImageElement) {
    const canvas: HTMLCanvasElement = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx: CanvasRenderingContext2D = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    const dataURL: string = canvas.toDataURL("image/png");

    return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  }

  // downloadFile() {
  //   this.plantService.getTemplate().subscribe((res) => {
  //     this.templateUrl = res;
  //   });
  // }
}